import { useQuery, QueryResult, FetchResult } from '@apollo/client'
import {
  EDIT_FLEXIBLE_BONUS_BY_EMPLOYEE_ID,
  FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING,
  IS_FLEXIBLE_PRORATA_MANAGEMENT_ENABLED,
  PAST_YEAR_FLEXIBLE_BONUS_BY_EMPLOYEE_ID_AND_MEETING,
} from './Queries'
import {
  Country,
  IsFlexibleProrataManagementEnabledQuery,
  IsFlexibleProrataManagementEnabledQueryVariables,
  FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQuery,
  FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQueryVariables,
  FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQuery,
  FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQueryVariables,
  EditFlexibleBonusByEmployeeIdMutation,
  EditFlexibleBonusByEmployeeIdMutationVariables,
} from '../../../../../types'
import { client } from '../../../../..'

export const useFlexibleProrataManagementEnabled = (
  country: Country,
): QueryResult<IsFlexibleProrataManagementEnabledQuery, IsFlexibleProrataManagementEnabledQueryVariables> => {
  return useQuery<IsFlexibleProrataManagementEnabledQuery, IsFlexibleProrataManagementEnabledQueryVariables>(
    IS_FLEXIBLE_PRORATA_MANAGEMENT_ENABLED,
    {
      variables: { country },
      fetchPolicy: 'network-only',
    },
  )
}

export const useFindBonusByEmployeeIdAndMeetingId = (
  employeeId: string,
  meetingId: string,
): QueryResult<FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQuery, FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQueryVariables> => {
  return useQuery<FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQuery, FindBonusByEmployeeIdInAppraisalSeasonOfMeetingQueryVariables>(
    FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING,
    {
      variables: { employeeId, meetingId },
      fetchPolicy: 'network-only',
    },
  )
}

export const useFindPastYearFlexibleBonusByEmployeeIdAndMeetingId = (
  employeeId: string,
  meetingId: string,
  skip = false,
): QueryResult<
  FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQuery,
  FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQueryVariables
> => {
  return useQuery<
    FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQuery,
    FindPastYearFlexibleBonusByEmployeeIdAndMeetingIdQueryVariables
  >(PAST_YEAR_FLEXIBLE_BONUS_BY_EMPLOYEE_ID_AND_MEETING, {
    variables: { employeeId, meetingId },
    fetchPolicy: 'network-only',
    skip,
  })
}

export const editFlexibleBonusByEmployeeId = async (
  bonusAmount: number,
  employeeId: string,
  meetingId: string,
): Promise<FetchResult<EditFlexibleBonusByEmployeeIdMutation>> => {
  return await client.mutate<EditFlexibleBonusByEmployeeIdMutation, EditFlexibleBonusByEmployeeIdMutationVariables>({
    mutation: EDIT_FLEXIBLE_BONUS_BY_EMPLOYEE_ID,
    variables: { bonusAmount, employeeId, meetingId },
    refetchQueries: [
      {
        query: FLEXIBLE_BONUS_BY_EMPLOYEE_ID_IN_AS_MEETING,
        variables: {
          employeeId,
          meetingId,
        },
      },
    ],
  })
}
